import { render } from "./TeacherTeaching.vue?vue&type=template&id=1cd17bc0&scoped=true"
import script from "./TeacherTeaching.vue?vue&type=script&lang=js"
export * from "./TeacherTeaching.vue?vue&type=script&lang=js"

import "./TeacherTeaching.vue?vue&type=style&index=0&id=1cd17bc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd17bc0"]])

export default __exports__